import { InjectionToken } from '@angular/core';

export const StorageInjectionToken: InjectionToken<Storage> = new InjectionToken<Storage>('StorageInjectionToken');
